export default "__VITE_ASSET__0$Bo5b3P__"